import * as React from "react";
import "./Icon.css";
const SvgDataIcon = ({ width, height, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    data-name="Layer 1"
    viewBox="0 0 48 48"
    width={width || undefined}
    height={height ? height : "auto"}
    fill="currentColor"
    {...props}
    className={`svg-icon shake-two-icon-target ${props.className || ""}`}
    style={{
      transformOrigin: "center",
      ...props.style,
      ...(width ? { width: width } : {}),
      ...(height ? { height: height } : {}),
    }}
  >
    <defs>
      <style>{".Data_Icon_svg__cls-1{fill:currentColor}"}</style>
    </defs>
    <path
      d="M28.61 12.6A16.44 16.44 0 1 0 44.92 29H28.61Z"
      className="Data_Icon_svg__cls-1"
    />
    <path
      d="M32.46 9.86 32.37 24 44 15.06c-2.09-6.56-6.09-7.71-11.54-5.2M45.43 18.53l-8.89 7H47c1.93-1.8.86-6.62-1.57-7M41.55 2.24V0H30v1.78a26.6 26.6 0 0 1 5.15-.72 12.8 12.8 0 0 1 6.4 1.18M26.71 0H15.16v11a23.3 23.3 0 0 1 11.55-4.16ZM5.81 31.94c-.87-9.2 1.6-14.14 5.74-19.19V0H0v48h11.55v-2.87c-2.78-2.2-4.99-5.21-5.74-13.19"
      className="Data_Icon_svg__cls-1"
    />
  </svg>
);
export default SvgDataIcon;
